import axios from "axios";

export default {
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.id 
     */
    getEpisodeDetail(obj) {
        return axios.post("/course/Study/getEpisodeDetail", obj);
    },
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.studyId 
     * @param {String} obj.episodeId 
     * @param {Array} obj.feeling 
     * @param {String} obj.other 
     */
    freeSeeFeeling(obj) {
        return axios.post("/course/Study/freeSeeFeeling", obj);
    }
}